import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'mar-navbar',
	standalone: true,
	templateUrl: 'navbar.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {}
